
import Vue from 'vue'
import BaseImage from '@/components/BaseImage.vue'

import { ProductCategory } from '@/model/productCategory'
import { SVG_PLACEHOLDER_IMAGES } from '@/constants'
export default Vue.extend({

  components: {
    BaseImage
  },
  props: {
    productCategories: {
      type: Array as () => Array<ProductCategory>,
      required: true
    },
    showMenu: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    currentCategory?: ProductCategory
    currentChildCategories?: Array<ProductCategory>
  } {
    return {
      currentCategory: undefined,
      currentChildCategories: undefined
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.CATEGORY_PARENT
    }
  },
  methods: {
    isCurrentCategory(category: ProductCategory): boolean {
      if (!this.currentCategory) {
        return false
      }

      return this.currentCategory.id === category.id
    },
    updateCurrentCategories(category: ProductCategory): void {
      this.currentCategory = category
      this.currentChildCategories = category.child_categories
    }
  }
})
